declare global {
  interface Window {
    _vis_opt_queue?: Array<(i: number) => void>;
    _vis_opt_goal_conversion: (i: number) => void;
  }
}

export const trackConvertica = async (): Promise<void> => {
  const trigger = document.getElementById('convertica');

  if (!trigger) {
    return;
  }

  return new Promise((resolve, reject) => {
    let resolved = false;
    window._vis_opt_queue = window._vis_opt_queue || [];
    window._vis_opt_queue.push(function() {
      window._vis_opt_goal_conversion(200);
      resolved = true;
      resolve();
    });

    window.setTimeout(() => {
      if (!resolved) {
        reject();
      }
    }, 2000);
  });
};
